import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

/*const stepsListExample = [
  { text: "3", active: true, completed: false },
  { text: "4", active: false, completed: true },
  { text: "5", active: false, completed: true },
  { text: "6", active: false, completed: true },
  { text: "7", active: false, completed: true },
  { text: "8", active: false, completed: true },
  { text: "9", active: false, completed: true },
  { text: "10", active: false, completed: true },
  { text: "11", active: false, completed: true },
  { text: "12", active: false, completed: true }
];*/

export interface Step {
  text: string;
  active: boolean;
  completed: boolean;
  tooltip: string;
}

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class StepperComponent implements OnInit {

  //@Input('example') example: boolean = false;
  @Input('steps') steps: Step[] = [];
  @Output('onchange') onchange: EventEmitter<number> = new EventEmitter<number>(); 

  constructor() { }

  ngOnInit() {
    // if (this.example) 
    //   this.steps = stepsListExample;
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/stepper/stepper.component.ts